export default {"src":"/_next/static/media/templates.817a773c.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};